import React from "react";

const MessagingUserCard = ({ _id, title, handelClick, color }) => {
  return (
    <button
      onClick={(e) => handelClick(e, _id, color,title)}
      className="transparentCardBtn w-full flex-row align-center justify-start p-b-05 g-1"
    >
      <div
        style={{
          width: "3rem",
          height: "3rem",
          borderRadius: "50%",
          backgroundColor: color,
        }}
      ></div>
      <h3 className="weight-500 pippins-medium">{title}</h3>
    </button>
  );
};

export default MessagingUserCard;
